var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPly(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 56,
    viewBox: "0 0 57 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.4997 0.0623779C22.9783 0.0623779 17.5809 1.69966 12.99 4.76718C8.39915 7.83471 4.821 12.1947 2.70805 17.2958C0.595104 22.3969 0.0422605 28.01 1.11943 33.4253C2.1966 38.8406 4.85541 43.8149 8.75962 47.7191C12.6638 51.6233 17.6381 54.2821 23.0534 55.3593C28.4687 56.4365 34.0818 55.8836 39.1829 53.7707C44.284 51.6577 48.644 48.0796 51.7115 43.4887C54.7791 38.8978 56.4164 33.5004 56.4164 27.979C56.4164 20.5751 53.4751 13.4744 48.2397 8.23898C43.0044 3.00359 35.9036 0.0623779 28.4997 0.0623779ZM35.9255 32.8086L32.3522 34.8745L28.7789 36.9403C24.1726 39.5924 20.4039 37.4149 20.4039 32.1107V23.8474C20.4039 18.5153 24.1726 16.3657 28.7789 19.0178L32.3522 21.0836L35.9255 23.1495C40.5318 25.8015 40.5318 30.1565 35.9255 32.8086Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPly);
export default __webpack_public_path__ + "static/media/ply.bf4ae339cf2791b37dc314c742f169b3.svg";
export { ForwardRef as ReactComponent };